import typography from '@amblique/king-living/app/theme/foundations/typography';

const ProductRange = {
  parts: [
    'container',
    'sectionHeading',
    'sectionTitle',
    'productList',
    'productGrid'
  ],

  baseStyle: {
    container: {
      display: 'flex',
      px: {base: 'unset', md: 20},
      pt: {base: 9, md: 0},
      pb: {base: 12, md: 30},
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: 6, // 24px consistent
      alignSelf: 'stretch',
      position: 'relative',
      maxWidth: '1440px',
      mx: 'auto',
    },

    sectionHeading: {
      display: 'flex',
      alignItems: 'flex-start',
      gap: 10, // 40px
      alignSelf: 'stretch',
      position: 'relative',
      px: {base: 5, md: 0}, // No extra padding, container handles it
    },

    sectionTitle: {
      flex: '1 0 0',
      ...typography.textStyles.sectionTitle,
      color: 'brandColors.greyscale90',
      position: 'relative',
      mb: 0,
    },

    productList: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: {base: 6, md: 10}, // 24px mobile, 40px desktop
      alignSelf: 'stretch',
      position: 'relative',
      px: {base: 1, md: 0}, // 4px padding for mobile grid spacing
      mx: {base: 'unset', md: 0},
    },

    productGrid: {
      // Range PLP default; Contentful Product Tiles grid overrides `lg` from `numberItemsPerView` (3 vs 4).
      columns: {base: 2, md: 3, lg: 4}, // 2 columns mobile, 3-4 desktop
      spacing: {base: 1, md: 1}, // 4px gap consistent from Figma design
      alignItems: 'flex-start',
      alignSelf: 'stretch',
      width: 'full',
      rowGap: {base: 6, md: 10},
      sx: {
        '& > *': {
          minWidth: 0,
        },
      },
    },

    ctaButtonContainer: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: 'full',
      pt: {base: 0, md: 14},
    },

    ctaButton: {
      display: 'flex',
      width: 'auto', // 216px mobile, auto desktop
      height: {base: '44px', md: '54px'}, // 44px mobile, 54px desktop
      minW: {base: '160px', md: '207px'}, // Minimum width constraints
      py: {base: '14px', md: 4}, // 14px mobile, 16px desktop
      px: {base: 12, md: 12}, // 48px both
      justifyContent: 'center',
      alignItems: 'center',
      alignSelf: {base: 'flex-start', md: 'center'}, // Left-aligned on mobile, centered on desktop
      gap: {base: 1.5, md: 2}, // 6px mobile, 8px desktop
      borderRadius: 'base', // 4px
      border: '1px solid',
      borderColor: 'brandColors.greyscale',
      bg: 'brandColors.greyscale',
      color: 'white',
      fontFamily: 'body',
      fontSize: 'sm', // 14px
      fontWeight: 'semibold', // 600
      lineHeight: '120%',
      cursor: 'pointer',
      transition: 'all 0.2s ease',
      flex: 'none',
      margin: '0 auto',
      whiteSpace: 'nowrap',
      _hover: {
        bg: 'transparent',
        color: 'brandColors.greyscale',
      },
    },
  },
};

export default ProductRange;
